import logoImage from '../../assets/images/LOGO_NIRVA.svg';
import { useNavigate } from 'react-router-dom';
import { SIMPLEPRACTICE_CLIENT_PORTAL_URL } from '../../utils/simplePractice';
import {
  FooterWrapper,
  FooterContainer,
  MainContent,
  LeftSection,
  LogoContainer,
  LogoImage,
  Description,
  CenterSection,
  SitemapTitle,
  SitemapGrid,
  SitemapColumn,
  FooterLink,
  FooterDivider,
  BottomSection,
  Copyright,
  LegalLinksContainer,
  LegalLink,
  LegalLinksWrapper,
  ButtonWrapper,
  SitemapContainer,
  DisclaimerSection,
  DisclaimerText,
} from './styles';
import { Box } from '@mui/system';
import CTAButton from '../../ui/ctaButton';
import SocialRow from '../SocialRow';

const Footer = () => {
  const navigate = useNavigate();
  const handleStartJourneyClick = () => {
    navigate('/your-journey');
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <FooterWrapper component="footer">
      <FooterContainer>
        <MainContent>
          <LeftSection>
            <LogoContainer onClick={handleLogoClick}>
              <LogoImage src={logoImage} alt="NIRVA Logo" />
            </LogoContainer>

            <Description>Empowering mental wellness with thoughtful online care.</Description>
          </LeftSection>

          <CenterSection>
            <SitemapContainer>
              <SitemapTitle>SITEMAP</SitemapTitle>

              <SitemapGrid>
                <SitemapColumn>
                  <FooterLink to="/about">About</FooterLink>
                  <FooterLink to="/practitioners">Practitioners</FooterLink>
                  <FooterLink to="/services">Services</FooterLink>
                </SitemapColumn>

                <SitemapColumn>
                  <FooterLink
                    as="a"
                    href={SIMPLEPRACTICE_CLIENT_PORTAL_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Client Portal
                  </FooterLink>
                  <FooterLink to="/contact">Contact</FooterLink>
                </SitemapColumn>
              </SitemapGrid>
            </SitemapContainer>
            <ButtonWrapper>
              <CTAButton
                variant="outlined"
                text="Start your Journey at Nirva"
                onClick={handleStartJourneyClick}
              />

              <SocialRow />
            </ButtonWrapper>
          </CenterSection>
        </MainContent>

        <FooterDivider />

        <BottomSection>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Copyright>Copyright © 2026 Nirva – Interpersonal Hypnotherapy Online Clinic</Copyright>
            <Copyright>
              All rights reserved. Not a substitute for medical or emergency care.
            </Copyright>
          </Box>
          <LegalLinksWrapper>
            <LegalLinksContainer>
              <LegalLink to="/scope-of-practice-and-legal-compliance">
                Scope of Practice & Legal Compliance
              </LegalLink>
            </LegalLinksContainer>
            <LegalLinksContainer>
              <LegalLink to="/terms-of-service">Terms of Service</LegalLink>
              <LegalLink to="/terms-and-conditions">Terms & Conditions</LegalLink>
              <LegalLink to="/privacy-policy">Privacy Policy</LegalLink>
            </LegalLinksContainer>
          </LegalLinksWrapper>
        </BottomSection>

        <DisclaimerSection>
          <DisclaimerText>
            Nirva Interpersonal Hypnotherapy Clinic is an independent organization and is not
            affiliated with, sponsored by, or endorsed by Nirva Health, Inc. or the
            &lsquo;Nerva&reg;&rsquo; program. &lsquo;Nerva&reg;&rsquo; is a separate digital
            program offering gut-directed hypnotherapy and is not associated with the services
            provided by Nirva Interpersonal Hypnotherapy Clinic.
          </DisclaimerText>
          <DisclaimerText>
            Any similarity in names, including common misspellings such as
            &lsquo;Nerva,&rsquo; is unintentional and does not imply any relationship between
            the organizations. Nirva Interpersonal Hypnotherapy Clinic provides its own distinct
            services within its defined professional scope of practice.
          </DisclaimerText>
        </DisclaimerSection>
      </FooterContainer>
    </FooterWrapper>
  );
};

export default Footer;
